<template>
  <div
    id="navigator">
    <div>
      <!-- <icon /> -->
      <BusinessDropdown
        ref="businessDropdown"
        :merchant="merchant"
        :no-hover="true"
        :button-style="BusinessDropdownTypes.NAVIGATION"/>
      <!-- <icon /> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#inbox {
  width: 258px;
  background-color: $greyUltralight;
  border-right: 1px solid $borderGray;
}
</style>

<script>
import { mapGetters } from 'vuex';
import BusinessDropdown from './BusinessDropdown';
import BusinessDropdownTypes from '../../helpers/lists/businessDropdownTypes';

export default {
  name: 'Navigator',
  components: {
    BusinessDropdown,
  },
  data() {
    return {
      BusinessDropdownTypes,
    };
  },
  computed: {
    ...mapGetters({
      merchant: 'merchant/merchant',
    }),
  },
  created() {},
  mounted() {
  },
  beforeDestroy() {},
  methods: {},
};
</script>
